import { benefits } from "../../../mocks/bizlab";
import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function BenefitsSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="benefits" className="py-24 bg-slate-50" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-xs font-bold uppercase tracking-widest text-blue-400 mb-3 block">
            Why BizLab
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Built for Enterprise Performance
          </h2>
          <p className="text-slate-500 text-base max-w-lg mx-auto">
            BizLab delivers measurable improvements across your organization — faster, smarter, and more transparent operations.
          </p>
        </div>

        {/* Benefits grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.id}
              className={`flex items-start gap-4 bg-white border-l-4 border-blue-400 rounded-xl p-6 hover:-translate-y-1 transition-all duration-300 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-blue-50 rounded-lg shrink-0">
                <i className={`${benefit.icon} text-blue-600 text-lg`} />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-slate-900 mb-1.5">{benefit.title}</h3>
                <p className="text-xs text-slate-500 leading-relaxed">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Image section below */}
        <div
          className={`mt-16 rounded-2xl overflow-hidden transition-all duration-700 delay-400 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="relative h-64 md:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20enterprise%20team%20collaboration%20open%20office%20workspace%20people%20working%20together%20at%20large%20white%20desks%20with%20laptops%20clean%20bright%20minimal%20corporate%20environment%20professionals%20in%20business%20casual%20attire&width=1280&height=480&seq=benefits1&orientation=landscape"
              alt="BizLab enterprise team collaboration workspace"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-blue-900/70 to-blue-900/30 flex items-center">
              <div className="max-w-lg ml-10 md:ml-16">
                <div className="text-2xl md:text-3xl font-bold text-white mb-3 leading-tight">
                  Trusted by 100+ Companies to Streamline Operations
                </div>
                <button
                  onClick={() => window.open("http://bizlab-demo.4-lab.com", "_blank")}
                  className="mt-2 inline-flex items-center gap-2 px-6 py-2.5 bg-white text-blue-400 text-sm font-semibold rounded-full hover:bg-blue-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  Request Demo
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
